import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import ProtectedRoute from './components/shared/ProtectedRoute';
import NotificationBanner from './components/shared/NotificationBanner';

// Pages
import LandingPage from './pages/LandingPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import AdminEventDetailPage from './pages/AdminEventDetailPage';
import KioskPage from './pages/KioskPage';
import GalleryPage from './pages/GalleryPage';
import GuestUploadPage from './pages/GuestUploadPage';
import ClientSetupPage from './pages/ClientSetupPage';
import ClientPortalPage from './pages/ClientPortalPage';
import ClientResetPasswordPage from './pages/ClientResetPasswordPage';

function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <NotificationBanner />
        <Router>
          <Routes>
            {/* Landing page */}
            <Route path="/" element={<LandingPage />} />

            {/* Admin routes */}
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route
              path="/admin/dashboard"
              element={
                <ProtectedRoute>
                  <AdminDashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/events/:eventId"
              element={
                <ProtectedRoute>
                  <AdminEventDetailPage />
                </ProtectedRoute>
              }
            />

            {/* Public Kiosk route */}
            <Route path="/kiosk/:eventId" element={<KioskPage />} />

            {/* Public Gallery route */}
            <Route path="/gallery/:eventId" element={<GalleryPage />} />

            {/* Public Guest Upload route */}
            <Route path="/upload/:eventId" element={<GuestUploadPage />} />

            {/* Client routes */}
            <Route path="/client/portal" element={<ClientPortalPage />} />
            <Route path="/client/setup/:eventId" element={<ClientSetupPage />} />
            <Route path="/client/reset-password" element={<ClientResetPasswordPage />} />

            {/* 404 - redirect to dashboard */}
            <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
          </Routes>
        </Router>
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;
